import { createGeneratePath } from '@itandi/tools/vanilla';

export const generatePath = createGeneratePath<
  | '/deals/:id'
  | '/deals/:deal_id/deal_todos'
  | 'deals/:deal_id/related_deals'
  | '/staffs'
  | '/staffs/:id'
  | '/staffs/:id/update_enabled'
  | '/staffs/login'
  | '/staffs/logout'
  | '/settings/company_construction_items'
  | '/company_construction_items'
  | '/vendors/vendor_company_password_resets'
>();
